export default {
  default: {
    editQuoteTemplate: 'Edit Quote Template',
    permissions: 'Permissions',
  },
}
